import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWineGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "wine-glass" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9,
			y1: 23.25,
			x2: 15,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12,
			y1: 23.25,
			x2: 12,
			y2: 14.561
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.887,6.517a6.969,6.969,0,0,1-2.534,6.5h0a6.968,6.968,0,0,1-8.706,0h0a6.969,6.969,0,0,1-2.534-6.5L5.9,1.386A.75.75,0,0,1,6.643.75H17.357a.75.75,0,0,1,.741.636Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.081,
			y1: 6.75,
			x2: 18.919,
			y2: 6.75
		})
	]
});
export default SvgWineGlass;
